export default __webpack_public_path__ + "static/media/PDPEditIcon.8cbb7590.svg";